/* Gaveta do carrinho (replica do Moonbundle Cart Drawer do concorrente) — secao cl-cart-drawer.
   Abre: icone do carrinho no header, ATC do buybox (cl-moonbundle.js), qualquer ATC nativo do Horizon (cart:update).
   Quantidade/remover/upsell pela Cart API com sections=<esta secao> (re-render sem recarregar). */
(function () {
  'use strict';
  if (window.__clCartDrawer) return;
  window.__clCartDrawer = true;

  function root() { return document.getElementById('cl-cart-drawer'); }
  function sectionId() { var r = root(); return r ? r.getAttribute('data-cl-drawer-section') : 'cl-cart-drawer'; }
  function drawer() { return document.getElementById('moonbundle-cart-drawer'); }

  function lock(on) {
    document.documentElement.style.overflow = on ? 'hidden' : '';
  }

  function open() {
    var d = drawer();
    if (!d) return;
    d.classList.remove('closing');
    d.classList.add('open');
    d.setAttribute('data-open', 'true');
    lock(true);
  }

  function close() {
    var d = drawer();
    if (!d) return;
    d.classList.remove('open');
    d.setAttribute('data-open', 'false');
    lock(false);
  }

  function replace(html) {
    var r = root();
    if (!r || !html) return;
    var wasOpen = drawer() && drawer().classList.contains('open');
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('#cl-cart-drawer');
    if (!fresh) return;
    r.replaceWith(fresh);
    if (wasOpen) { var d = drawer(); d.classList.add('open'); d.setAttribute('data-open', 'true'); }
  }

  function bubble(count) {
    // contador do icone do carrinho do Horizon (cart-bubble)
    document.querySelectorAll('.cart-bubble__text-count, [ref="cartBubbleCount"]').forEach(function (el) {
      el.textContent = count > 0 ? count : '';
    });
    document.querySelectorAll('.cart-bubble').forEach(function (el) {
      el.classList.toggle('visually-hidden', !(count > 0));
    });
    document.querySelectorAll('cart-icon, .header-actions__cart-icon').forEach(function (el) {
      el.classList.toggle('header-actions__cart-icon--has-cart', count > 0);
    });
  }

  function refresh(sections) {
    var sid = sectionId();
    var p = sections && sections[sid] ? Promise.resolve(sections[sid])
      : fetch(window.location.pathname + '?sections=' + encodeURIComponent(sid), { credentials: 'same-origin' })
        .then(function (r) { return r.json(); }).then(function (j) { return j[sid]; });
    return p.then(function (html) {
      replace(html);
      var n = root() && root().querySelector('.moonbundle-cart-drawer-header-item-count');
      bubble(n ? parseInt(n.textContent, 10) || 0 : 0);
    });
  }

  function toast(msg) {
    if (!msg) return;
    var t = document.createElement('div');
    t.textContent = msg;
    t.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:100000;background:var(--moonbundle-cartdrawer-cartAddErrorToast-bgColor,#dc3545);color:#fff;padding:10px 16px;border-radius:8px;font:600 14px/1.3 Inter,sans-serif;max-width:90vw;text-align:center';
    document.body.appendChild(t);
    setTimeout(function () { t.remove(); }, 4000);
  }

  // API publica (o quick-add e o kit chamam este nome, como no tema dele)
  window.openMoonBundleCartDrawer = function (err, sections) {
    if (err) toast(err);
    return refresh(sections).then(open);
  };
  window.clCartDrawer = { open: open, close: close, refresh: refresh };

  function busy(el, on) { var c = el && el.closest('.moonbundle-cart-item, [data-cl-upsell]'); if (c) c.classList.toggle('moonbundle-loading', on); }

  function change(key, qty, el) {
    busy(el, true);
    return fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty, sections: sectionId() })
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { busy(el, false); toast(res.j.description || res.j.message); return; }
        return refresh(res.j.sections);
      }).catch(function () { busy(el, false); });
  }

  function upsellVariant(card) {
    var list = [];
    try { list = JSON.parse(card.querySelector('script[data-cl-variants]').textContent); } catch (e) {}
    var want = {};
    card.querySelectorAll('[data-cl-opt]').forEach(function (el) {
      var i = el.getAttribute('data-cl-opt');
      if (el.tagName === 'SELECT') want[i] = el.value;
      else if (el.getAttribute('aria-checked') === 'true') want[i] = el.getAttribute('data-value');
    });
    var v = list.filter(function (x) {
      for (var i in want) if (x.o[i] !== want[i]) return false;
      return true;
    })[0];
    return v || null;
  }

  // icone do carrinho do header -> a MESMA gaveta do ATC. Captura no WINDOW: o botao do Horizon
  // (on:click="#cart-drawer/toggle") e ouvido no document e abria a gaveta nativa junto/no lugar da nossa.
  // Abre ja e atualiza o conteudo depois (o replace mantem aberta).
  window.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest || !root()) return;
    var icon = t.closest('[data-testid="cart-drawer-trigger"], .header-actions__cart-icon, header a[href="/cart"], header a[href$="/cart"], cart-drawer-component button');
    if (!icon || root().contains(icon)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open();
    refresh().catch(function () {});
  }, true);

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    if (!root() || !root().contains(t)) return;
    if (t.closest('[data-cl-close]')) { e.preventDefault(); close(); return; }
    var q = t.closest('.moonbundle-quantity-btn');
    if (q && !q.disabled) {
      var inp = q.parentNode.querySelector('.moonbundle-quantity-input');
      var n = parseInt(inp.value, 10) || 1;
      change(q.getAttribute('data-item-key'), q.getAttribute('data-action') === 'increase' ? n + 1 : Math.max(0, n - 1), q);
      return;
    }
    var rm = t.closest('.moonbundle-cart-item-remove');
    if (rm) { change(rm.getAttribute('data-item-key'), 0, rm); return; }
    var sw = t.closest('.moonbundle-cart-swatch-btn');
    if (sw) {
      sw.parentNode.querySelectorAll('.moonbundle-cart-swatch-btn').forEach(function (b) {
        var on = b === sw;
        b.classList.toggle('moonbundle-cart-swatch-btn--selected', on);
        b.setAttribute('aria-checked', on ? 'true' : 'false');
      });
      return;
    }
    var add = t.closest('[data-action="add-upsell"]');
    if (add) {
      var card = add.closest('[data-cl-upsell]');
      var v = upsellVariant(card);
      if (!v || !v.a) { toast('Out of stock'); return; }
      busy(add, true);
      fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }], sections: sectionId() })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) { busy(add, false); toast(res.j.description || res.j.message); return; }
          return refresh(res.j.sections);
        });
      return;
    }
    if (t.closest('[data-cl-checkout]')) { window.location.href = '/checkout'; }
  }, true);

  document.addEventListener('change', function (e) {
    var inp = e.target.closest && e.target.closest('#cl-cart-drawer .moonbundle-quantity-input');
    if (inp) change(inp.getAttribute('data-item-key'), Math.max(0, parseInt(inp.value, 10) || 0), inp);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer() && drawer().classList.contains('open')) close();
  });

  // ATC nativo do Horizon (quick add, product-form fora do buybox): o tema dispara cart:update
  document.addEventListener('cart:update', function (e) {
    var d = e.detail || {};
    if (d.sourceId === 'cl-cart-drawer') return;
    if (d.data && d.data.didError) return;
    window.openMoonBundleCartDrawer();
  });
})();
